module.exports = __webpack_public_path__ + "static/media/text-variant.fcbb2ec0.png";